import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b36a8c6c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=b36a8c6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36a8c6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b36a8c6c')) {
      api.createRecord('b36a8c6c', component.options)
    } else {
      api.reload('b36a8c6c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b36a8c6c&scoped=true&", function () {
      api.rerender('b36a8c6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/components/drawer/index.vue"
export default component.exports